module.exports = __webpack_public_path__ + "static/media/icon-pill.af80cafc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-pill.svg
// module id = 270
// module chunks = 0